import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ValuesAccessorBase } from '../custom-control/ValueAccesorBase';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ListItem } from './ListItem';

@Component({
  selector: 'app-dropdown-list',
  templateUrl: './dropdown-list.component.html',
  styleUrls: ['./dropdown-list.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DropdownListComponent,
    multi: true
  }]
})
export class DropdownListComponent
  extends ValuesAccessorBase<string>
  implements OnInit {

  @Input() label: string;
  @Input() obrigatorio: Boolean;
  @Input() name: string;
  @Input() itens: ListItem[];
  @Input() valorVazio = '0';
  @Output() selecionar: EventEmitter<any> = new EventEmitter<any>();

  dadosTranslate = {
    "Janeiro": "dropDownList.meses.janeiro",
    "Fevereiro": "dropDownList.meses.fevereiro",
    "Marco": "dropDownList.meses.marco",
    "Abril": "dropDownList.meses.abril",
    "Maio": "dropDownList.meses.maio",
    "Junho": "dropDownList.meses.junho",
    "Julho": "dropDownList.meses.julho",
    "Agosto": "dropDownList.meses.agosto",
    "Setembro": "dropDownList.meses.setembro",
    "Outubro": "dropDownList.meses.outubro",
    "Novembro": "dropDownList.meses.novembro",
    "Dezembro": "dropDownList.meses.dezembro"
  }

  ngOnInit() { }

  seleciona() {
    this.selecionar.emit(this.value);
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

}
